module.exports = __webpack_public_path__ + "img/win.715fa587.png";